<template>
  <div>
    <div class="left_tree" v-show="showLeft">
    <a-spin :spinning="treeSpin" style="height: 100%">
      <div>
        <a-radio-group v-model="type" @change="handleChange">
          <a-radio-button value="dept">
            部门
          </a-radio-button>
          <a-radio-button value="customer">
            员工
          </a-radio-button>
        </a-radio-group>
        <vxe-button @click="closeAll" style="margin-top: 12px">清空</vxe-button>
      </div>
      <div class="tree-box" v-if="type === 'dept'">
        <a-tree
            v-model="checkedKeys"
            :show-icon="true"
            checkable
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :selected-keys="selectedKeys"
            :tree-data="treeData"
            :selectable="false"
            :replaceFields="{children:'children', title:'deptName', key:'deptId'}"
            @expand="onExpand"
            @check="onSelect"
        >
          <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
          <a-icon type="cluster" slot="region" style="color:#52c41a"/>
        </a-tree>
      </div>
      <div class="tree-box" v-if="type === 'customer'">
        <Tree :list="treeData" :selectedUser="selectedUser" :userName="''" :detph="0"
              @change="checkedUser"></Tree>
      </div>
    </a-spin>
  </div>
    <div class="right_table" :class="{showLeft:!showLeft}">
      <a-icon type="left-circle" class="close" @click="showLeft = false" v-if="showLeft"/>
      <a-icon type="right-circle" class="close" @click="showLeft = true" v-else/>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
        :other-params="{'filter.orderByDesc.createDate':true,regionId,dealerId,deptId,userId}"
    >

    </x-grid>


    <!-- 详情页 -->
    <formModal
        title="活动报账详情"
        centered
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1040"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :rowId="editRowId"
          :actId="chooseActId"
          v-if="editModalVisible"
          ref="detailForm"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)"
      >
      </detailForm>
    </formModal>

    <!-- 选择活动 弹窗 -->
    <a-modal
        title="选择活动"
        centered
        :footer="null"
        :maskClosable="true"
        v-model="showActPop"
        :width="1200"
        :closable="true"
    >
      <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
      <actList
          v-if="showActPop"
          ref="actList"
          @close="closeTransferPop"
          @chooseAct="chooseAct"
      >
      </actList>
    </a-modal>

    </div>
  </div>
</template>

<script>
  import XGrid from "@/components/grid/XGrid";
  import {GridMixin} from "@/utils/GridMixin";
  import {formatter as fmt} from "@/utils/ebase-formatter";
  import api from "@/services/api";
  import {loadBaseCodeData} from "@/services/baseCodeSource";

  console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除
  import detailForm from "@/pages/web/activityManage/activityAccount/activityAccountDetail";
  import {dataApi} from "@/services/activityManage/activityList";
  import actList from "./poolPop/actList";
  // import {mapMutations} from "vuex";
  //新增的
  import {XEUtils} from "@/utils/common/FormBase";
  import Tree from "@/components/picker/Tree";

  //新增的结束
  const fac = XGrid.factory;

  //列表接口
  const url = api.activity.ACTIVITYACCOUNT;

  //主键
  const rowId = "accountId";

  //列
  const columns = [
    fac.makeColumnCheckboxDefault(),
    fac.makeColumnSeqDefault(),
    fac.makeColumn("activityNo", "活动编号", 140),
    fac.makeColumn("activityName", "活动名称", 140),
    fac.makeColumn("activityTypeName", "活动类型", 120, "center"),
    fac.makeColumn("auditStatusName", "报账状态", 120, "center"),
    fac.makeColumn("regionName", "经理部", 140, "center"),
    fac.makeColumn("dealerName", "经销商", 140, "center"),

    fac.makeColumn("createUserName", "提报人", 140, "center"),
    fac.makeColumn("createDate", "提报时间", 160, "center"),
  ];

  const formConfig = fac.makeFormConfig(columns, [
    /*{
      field: "activityTypeName",
      type: "select",
      options: [],
    },*/
    {field: 'activityNo'},//活动编号
    {field: "activityTypeName"},//活动类型
    {field: "activityName"},//活动名称
    // {field: "regionName"},//经理部
    // {field: "dealerName"},//经销商
    // {field: 'createUserName'},//提报人
    {
      field: 'createDate',
      title: "活动开始时间",
      type: 'dateRange',
    },
  ]);

  //工具栏按钮
  const toolbarConfig = fac.makeToolbarConfig({
    export: true,
    import: false,
    delData: false,
    templatelSlots: "toolbarBtns",
  });

  //可编辑表格约束
  const printConfig = fac.makePrintConfig(columns);
  const pagerConfig = fac.makePagerConfig();
  const checkboxConfig = fac.makeCheckboxConfig(columns);

  async function loadBaseData() {
    /*this.activityTypeNameOptions = await loadBaseCodeData('CD400003')
    this.activityTypeNameOptions = this.activityTypeNameOptions.map(v => {
      return {
        label: v.label,
        value: v.label
      }
    })
    this.activityTypeNameOptions = [{
      value: '',
      label: '全部'
    }].concat(this.activityTypeNameOptions);
    this.loadSearchOption({
      activityTypeName: this.activityTypeNameOptions,
    })*/

  }


  export default {
    mixins: [GridMixin],
    authorize: {
      // addRow: "ADD",
      // updateRow: 'UPDATE',
      // delRow: 'DELETE',
      // importMethod:'IMPORT',
      // exportMethod:'EXPORT',
    },
    components: {
      detailForm,
      //新增的开始
      Tree,
      //  新增的结束
      actList,
    },
    computed: {
      // ...mapState("account", { currUser: "user" }),
    },
    data() {
      return {
        activityTypeNameOptions:[],
        columns,
        rowId,
        url,
        formConfig,
        toolbarConfig,
        printConfig,
        checkboxConfig,
        pagerConfig,
        natureOptions: [],
        cstegoryOptions: [],
        regionOptions: [],
        dealerOptions: [],
        visible: false,
        value: 1,
        showActPop: false,//弹窗选择活动
        editModalVisible: false,//报账明细
        chooseActId: '',//活动id

        //  新增的
        regionId: '', dealerId: '', deptId: '',userId:'',
        //角色树
        autoExpandParent: false,
        defaultExpandedKeys: [],
        selectedKeys: [],
        expandedKeys: [],
        checkedKeys: [],
        deptList: [],
        treeData: [],
        selectedUser: [],
        treeSpin: false,
        showLeft: false,
        type: 'dept',
        //  新增的结束
      };
    },
    mounted() {
      //  新增的
      this.init()
      //  新增的结束
    },
    methods: {
      loadBaseData,
      addRow(){
        this.showActPop = true
      },
      //关闭选择活动弹窗
      closeTransferPop() {
        this.showActPop = false; //经销商树
        this.refresh();
      },
      //选择活动--确定
      chooseAct(actId){
        this.showActPop = false;
        this.chooseActId = actId;
        this.editModalVisible = true;//新增报账明细
        console.log('选择的活动id', this.chooseActId);
      },

    //  新增的
    init() {
      dataApi.popSelect().then(res => {
        this.treeData = XEUtils.toArrayTree(res.data, {
          parentKey: 'parentId',
          key: 'deptId',
          children: 'children'
        })
      })
    },
    handleChange() {
      this.closeAll()
      this.init()
    },
    closeAll() {
      this.checkedKeys = []
      this.userId = ''
      this.regionId = ''
      this.dealerId = ''
      this.deptId = ''
      XEUtils.mapTree(this.treeData, item => {
        if (item.userList) {
          item.userList.map(user => {
            user.checked = false
          })
        }
        return item
      })
      this.selectedUser = []
      this.$nextTick(() => {
        this.refresh()
      })
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys, {checkedNodes}) {
      this.selectedKeys = selectedKeys
      let regionId = [], dealerId = [], deptId = []
      checkedNodes.forEach(item => {
        if (item.data.props.isDealer === 1) {
          dealerId.push(item.key)
        } else if (item.data.props.isRegion === 1) {
          regionId.push(item.key)
        } else {
          deptId.push(item.key)
        }
      })
      this.regionId = regionId.toString()
      this.dealerId = dealerId.toString()
      this.deptId = deptId.toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },
    checkedUser(user) {
      if (user.checked) {
        this.selectedUser.push(user)
      } else {
        this.selectedUser = this.selectedUser.filter(item => item.userId !== user.userId)
      }
      this.userId = this.selectedUser.map(item => {
        return item.userId
      }).toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },

    //  新增的结束
    },
  };
</script>

<style scoped lang="less">
  /deep/ .ant-radio-group {
    display: flex;
    width: 100%;

    .ant-radio-wrapper {
      flex: 1;
    }

    .item {
      margin: 16px 0;
    }
  }
  //新增的开始

  .left_tree {
    width: 260px;
    float: left;
    padding: 20px;
    height: calc(100vh - 48px - 64px);
    border-right: 1px solid #e0e0e0;
    background: #fff;
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
  }

  .right_table {
    width: calc(100% - 260px);
    float: right;
    height: 100%;
    position: relative;

    .close {
      position: absolute;
      top: 50%;
      left: -18px;
      display: block;
      z-index: 1000;
      font-size: 36px;
      cursor: pointer;
      color: #fff;
      background-color: #bbb;
      border-radius: 18px;
    }
  }

  .showLeft {
    width: 100%;
  }

  //新增的结束
</style>
